import { FeatureFlagsDefs, CattFeatureFlagDefs } from "./shared/lib/types";
import sniffProject from "./shared/lib/sniffProject";
import { EventAttendence } from "./shared/lib/graphql";

const defaultEventAttendanceTitles = {
  [EventAttendence.Yes]: "Attended",
  [EventAttendence.No]: "Did not attend",
  [EventAttendence.Rescheduled]: "Rescheduled",
  [EventAttendence.Excused]: "Excused",
  default: "Not attendance set",
};

const DEFAULT_FLAGS: FeatureFlagsDefs = {
  messages: {
    broadcastMessagesHeaderString:
      "Schedule messages to be sent to all client or a specific group.",
  },
  helpUrl: "",
  supportsCarePlanEditing: true,
  supportsProgramCompliance: true,
  whatIsRiskLevelCalled: "Risk Level",
  supportsAssessment: true,
  showTasksInClientTable: true,
  showEventsInClientTable: true,
  showProgramTitleInClientTable: false,
  showRiskLevelInClientTable: false,
  showSmsStatusInClientTable: true,
  showStartDateInClientTable: false,
  showAddressInClientTable: false,
  showHasAppInClientTable: false,
  showDataUpdateNeededInClientTable: false,
  showProbationOfficerInClientTable: false,
  clientListPageName: "Clients",
  clientDisplayTerm: "Client",
  caseManagerDisplayTerm: "Case Manager",
  whatIsComplianceCalled: "Progress",
  whatIsDispositionCalled: "Outcome",
  goalsTasks: {},
  supportsClientProfile: false,
  clientDetailsColumnsToDisplay: {
    address: false,
    phone: true,
    name: true,
    case_manager: true,
    cases: false,
    language: true,
    access_code: true,
    joined: false,
    supervision_begin_date: true,
    supervision_end_date: true,
    sms_consent: true,
    sms_enabled: true,
    risk_level: true,
    compliance: true,
    currentDevice: false,
  },
  sortClientListByNextEvent: false,
  clientProfileAdditionalRows: {},
  timeline: {},
  supportsBroadcastMessaging: true,
  broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
  supportsChat: true,
  supportsAddingObligationsToCarePlan: true,
  supportsDateRangesOnObligations: true,
  workflow: { display: true, reviewIsLegacy: true },
  supprtsChatLogDownload: false,
  logoDataURI: null,
  deactivation: {
    allowDeactivation: true,
    populateEndDateOnDeactivation: true,
  },
  showRecurrence: false,
  formatting: { startDateHumanizeCutoff: 90 },
  showAnalyticsReportLink: false,
  lastNameFirst: false,
  eventAttendanceTitles: defaultEventAttendanceTitles,
};

const CLIENT_CONFIGS: { [key: string]: FeatureFlagsDefs } = {
  "promise-demo-dashboard": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    helpUrl: "",
    supportsClasses: true,
    supportsClientDocuments: true,
    supportsCarePlanEditing: true,
    supportsProgramCompliance: true,
    whatIsRiskLevelCalled: "Type",
    supportsAssessment: false,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Site",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Outcome",
    goalsTasks: {},
    supportsClientProfile: false,
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: true,
      supervision_end_date: true,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: false,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
    supportsChat: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: true, reviewIsLegacy: true },
    supprtsChatLogDownload: true,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: true,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: true,
    formatting: { startDateHumanizeCutoff: 90 },
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "cass-county": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    goalsTasks: {},
    supportsClientProfile: true,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: true,
    supportsClientDocuments: true,
    whatIsRiskLevelCalled: "Risk Level",
    supportsAssessment: true,
    supportsCases: true,
    supportsParticipantRiskAssessments: true,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: true,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: true,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Outcome",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: true,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    supportsCaseAnalytics: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
    supportsChat: true,
    supportsNotes: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: true, reviewIsLegacy: true },
    supprtsChatLogDownload: false,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: true,
      populateEndDateOnDeactivation: true,
    },
    showRecurrence: true,
    formatting: {},
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "alameda-pre": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    goalsTasks: { display: false },
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: false,
    supportsClientDocuments: false,
    whatIsRiskLevelCalled: "Risk Level",
    supportsAssessment: false,
    supportsCases: false,
    supportsParticipantRiskAssessments: false,
    showTasksInClientTable: false,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Outcome",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: false,
      cases: false,
      language: true,
      access_code: false,
      joined: false,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: false,
      compliance: false,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    supportsCaseAnalytics: false,
    broadcastMessagingBuckets: ["all"],
    supportsChat: true,
    supportsNotes: true,
    supportsAddingObligationsToCarePlan: false,
    supportsDateRangesOnObligations: false,
    workflow: { display: false },
    supprtsChatLogDownload: true,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: true,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: false,
    showHealthLink: true,
    lastNameFirst: true,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "lca-alameda": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all EIC clients or just those assigned to a particular case manager.",
    },
    goalsTasks: {},
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: false,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Case Manager",
    supportsAssessment: true,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Client Task Management",
    defaultTabInClientDetails: "goalsTasks",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Compliance",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: true,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: false,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level"],
    supportsChat: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: true, reviewIsLegacy: true },
    supprtsChatLogDownload: false,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: true,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "lca-alameda-staging": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all EIC clients or just those assigned to a particular case manager.",
    },
    goalsTasks: {},
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: false,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Case Manager",
    supportsAssessment: true,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Client Task Management",
    defaultTabInClientDetails: "goalsTasks",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Compliance",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: true,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: false,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level"],
    supportsChat: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: true, reviewIsLegacy: true },
    supprtsChatLogDownload: false,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: true,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "tdrc-alameda": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all trdc clients or just those assigned to a particular case manager.",
    },
    goalsTasks: {},
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Case Manager",
    supportsAssessment: true,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Client Task Management",
    defaultTabInClientDetails: "goalsTasks",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Compliance",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: true,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: false,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level"],
    supportsChat: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: false, reviewIsLegacy: true },
    supprtsChatLogDownload: false,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: true,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "marin-pretrial": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    goalsTasks: {
      display: true,
      whatIsGoalCalledPlural: "Conditions of Release",
      whatIsGoalCalledSingular: "Condition",
      whatIsTaskCalledPlural: "Goals",
      whatIsTaskCalledSingular: "Goal",
      goalsAndTasksTabLabel: "Conditions of Release",
    },
    supportsCases: false,
    supportsBookings: true,
    supportsProspects: true,
    supportsCarePlanSetup: true,
    supportsClientProfile: true,
    supportsVictims: true,
    supportsClientDocuments: true,
    supportsParticipantRiskAssessments: true,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Monitoring Level",
    supportsAssessment: false,
    showTasksInClientTable: false,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: false,
    showStartDateInClientTable: true,
    showEndDateInClientTable: true,
    showAddressInClientTable: false,
    showHasAppInClientTable: true,
    showCaseNumberInClientTable: true,
    showDataUpdateNeededInClientTable: false,
    showProbationOfficerInClientTable: true,
    defaultTabInClientDetails: "profile",
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: true,
      phone: true,
      name: true,
      case_manager: false,
      cases: true,
      language: true,
      currentDevice: false,
      access_code: true,
      joined: false,
      supervision_begin_date: true,
      supervision_end_date: true,
      sms_consent: true,
      sms_enabled: true,
      risk_level: false,
      compliance: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {
      is_supervised_probation: true,
      probation_officer_name: true,
    },
    timeline: {
      hideNotifications: true,
    },
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: false,
    workflow: { display: true, reviewIsLegacy: true },
    supprtsChatLogDownload: false,
    supportsChat: true,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: true,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: false,
    lastNameFirst: true,
    eventAttendanceTitles: {
      [EventAttendence.Yes]: "Completed",
      [EventAttendence.No]: "Incomplete",
      [EventAttendence.Rescheduled]: "Rescheduled",
      [EventAttendence.Excused]: "Excused",
      default: "Incomplete",
    },
  },
  "marin-county": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    goalsTasks: {
      display: false,
    },
    supportsClientProfile: false,
    supportsClientAccounting: true,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Supervision Level",
    supportsAssessment: false,
    supportsProbationNumber: true,
    showTasksInClientTable: false,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: true,
    showDataUpdateNeededInClientTable: true,
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: true,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      currentDevice: true,
      access_code: true,
      joined: false,
      supervision_begin_date: true,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: false,
      compliance: false,
      probationNumber: true,
    },
    sortClientListByNextEvent: false,
    includeCheckInEventsInNextEventDisplay: true,
    clientProfileAdditionalRows: {},
    timeline: {
      hideNotifications: true,
    },
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: {
      display: true,
      reviewIsLegacy: true,
      showCheckInDownload: true,
    },
    supprtsChatLogDownload: false,
    supportsChat: true,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: true,
    formatting: {},
    showAnalyticsReportLink: false,
    lastNameFirst: true,
    eventAttendanceTitles: {
      [EventAttendence.Yes]: "Completed",
      [EventAttendence.No]: "Incomplete",
      [EventAttendence.Rescheduled]: "Rescheduled",
      [EventAttendence.Excused]: "Excused",
      default: "Incomplete",
    },
  },
  "pdp-sf": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    goalsTasks: {},
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Assessment",
    supportsAssessment: true,
    showTasksInClientTable: false,
    showEventsInClientTable: false,
    showProgramTitleInClientTable: true,
    showRiskLevelInClientTable: true,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "program", "caseload", "activity"],
    broadcastMessagingBucketsProgramRegexes: [
      {
        name: "Supervision: ACM",
        regex: ".*ACM.*",
      },
      {
        name: "Supervision: OR only",
        regex: ".*^(?!ACM).*",
      },
    ],
    supportsAddingObligationsToCarePlan: false,
    supportsDateRangesOnObligations: false,
    workflow: { display: true, reviewIsLegacy: true },
    supprtsChatLogDownload: false,
    supportsChat: true,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "solano-cpc-dev": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
      display: true,
    },
    goalsTasks: { display: false },
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: true,
    whatIsRiskLevelCalled: "Office",
    supportsAssessment: true,
    showTasksInClientTable: false,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: true,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Solano CPC Case Management",
    clientDisplayTerm: "Client",
    supportsClasses: true,
    caseManagerDisplayTerm: "Case Manager",
    whatIsDispositionCalled: "Disposition",
    whatIsComplianceCalled: "Compliance",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: true,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    supportsCalendar: true,
    broadcastMessagingBuckets: [
      "all",
      "caseload",
      "risk_level",
      "activity",
      "risk_level_by_sex",
    ],
    supportsChat: true,
    supportsNotes: false,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: true },
    supprtsChatLogDownload: false,
    logoDataURI:
      "data:image/jpeg,%FF%D8%FF%E0%00%10JFIF%00%01%01%00%00%01%00%01%00%00%FF%DB%00%84%00%08%06%06%0D%0D%0D%10%0D%0D%10%0F%0D%0E%0D%0F%0E%0F%0D%0D%0E%0D%0F%0E%0D%10%0E%11%10%13%12%1D%0F%10%11%15%18.%1B%15%16%20%17%10%10%1C%2B%1D%20%24%25%28%28%28%15%1B-1%2C%260%22%27%28%26%01%09%09%09%0D%0C%0D%19%0E%0E%18%26%1F%1D%1F%26%26%27%26%26%26%27%27%26%26%26%26%26%27%26%26%27%26%27%26%26%26%26%26%26%26%27%26%26%27%27%26%26%26%26%27%27%26%26%26%26%27%26%26%26%26%26%26%26%26%FF%C0%00%11%08%00z%00%D4%03%01%11%00%02%11%01%03%11%01%FF%C4%00%1C%00%01%00%01%05%01%01%00%00%00%00%00%00%00%00%00%00%00%06%01%02%03%05%07%08%04%FF%C4%00A%10%00%01%03%02%03%03%05%0C%09%04%03%01%00%00%00%00%02%00%01%03%04%12%05%06%11%07%13%21%221AQa2BRSbqr%81%82%A2%A3%D1%14%15%173C%91%92%93%A1T%B1%D2%D35%C2%F1%23%FF%C4%00%1B%01%01%00%02%03%01%01%00%00%00%00%00%00%00%00%00%00%00%03%04%01%02%05%06%07%FF%C4%003%11%01%00%02%02%01%03%03%02%05%02%04%07%00%00%00%00%00%01%02%03%11%04%05%12%21%131A%06Q%14%22BRa%15%F0%162%A1%F1%23Sq%81%91%C1%E1%FF%DA%00%0C%03%01%00%02%11%03%11%00%3F%00%EF%E8%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%28%B1%132J%07%8Fmk%08%A1%90%A1%29Ny%05%F41%A6%0D%E3%09x%24W0%EB%EBW%B1p2%E4%8D%C4%11%0DW%DB%C6%11%E2%EB%3Ff%2F%F6%29%3F%A6gI%14%DA%BFn%D8O%8B%AC%FD%98%BF%D8%B1%FD73x%C12%BE%0D%B8a%04%EC%C45%40%CF%DF%14%22%EC%DF%A4%DD%D4s%C1%BC3%3Ci%94%EF%08%C6%A9%ABai%E9e%19%A3~b%07%E6~%A2nv~%C7U%AFI%AF%BA%2C%94%9A%7B%B6kF%82%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0Es%B6%3C%C7%25%0E%17l%04%E1-%5C%9B%861%7D%08B%D2%22%21%ED%B4m%F6%97G%A6a%8C%B9%3C%FC%12%F3%23%2F_%DB%5Cq%E1%25as%28m6X%AB%2B%3A%82%D6%B2%CDt%BD%95y%FC%D0%B1%1A%84%EFey%86J%2CN%28%D9%DFsXM%04%A1%AF%25%C8%BB%92%F4%98%AD%F5%11.W%2B%0C%7B%A2%E5a%8BWoN2%E4%B8%E2%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0A%21%0C3%CC%11%89Hn%C2%00%CEFN%FA%08%8Bqrt%A5f%F3%A8%26%5ER%DA%16w%93%18%ACr%17%21%A4%85%DCib~%AE%99%88%7C%22%FE%1BF%5E%CF%A6p%BF%0F_%3E%F2%D2%25%12ez%DB%A4%ED%3DW2%82%F13%29%EA%C8%CA%0C%BB%88Y%AF%96Ae%5Eg%C2%C5%2B%A6xe%20%210w%13%12b%12%17%D0%84%87%98%84%95%3C%9B%AA%C6%B7%0FL%EC%DF8%7DkF%CF%26%8DSOhT7%85%D5%2F%B5k%FA%C4%97%1B.%3E%C7%17%95%C7%F4%EC%9B%2A%F1%3BUQn%C6%A4C%CA%AB%0C%8B%26%C5%83%C0%B2j%0D%166x4C%C1%A2%1A4M%9E%04%04%14%D1%3D%CF%22%1A%95%C8%08%08%28%B1%F09%5E%DCs%23%D2%E1%C3I%1B%E9%25y%90%16%8F%C5%A0%8E%D2%2F%CE%E8%C7%CCD%BA%FD%17%8D%EA%E5%DC%FC%23%BC%BC%E5%0CDd%20%0C%E4dL%22%22%DA%91%11rXEz%FC%96%8AS%B9%88t%ACocU%D4t%0FX%F2%C71%C6%1B%CA%8Aq%12%D4%03%A6%D3%EF%F4%E3%AF2%E1%D3%ACV%F7%ED%94%F0%F8%F2%A6%CB%2BqZV%AB%82Zx%E3%220a%90%A4%BFQ%E4%BFr.%B5%E5u%18%C7m%24%EEh%B3.V%AA%C2%AA%3E%8FT%C3%A9%0D%F1%C8%0F%ACr%07%84.%A4%C3%CA%8C%D0%B3%8A%E96O%D9uV%2BLUM%20%D3%C6%EE%E3%0D%E0%E6%F2%B8%F3%97%0Ea%BB%93%AF%9DQ%E4%F2%E2%97%D47%B6%7D%22%98%9E%1B-%25D%94%B3%8D%92%C2V%1Bw%BE%90%F9%25%CE%B6%F5%22%F5%DA%F7%1E%DD%CD%A6T%CD%15%18UC%D4%40%C2n%60%F1%9Cr%5Da%0Fm%BDN%2A%AEjE%E1%26~%3F%AD%E18%FBp%C4%3F%A7%A6%F8%BF%E4%A9N%28%84q%D1%E3%5E%EB%9Bm%F5%FF%00%D3%D3%7C_%9A%8AcIc%A2%D3%F7%2Fm%B6W%FF%00OM%F1~j%29%BE%92%C7%40%A4%FE%A9U%B6%D5%5E%FF%00%81M%F1~j9%CC%9A%3E%9C%C3%3F%AAW6%DA%2B%BCE7%C5%F9%A8%A7%3AX%FAc%0C%FE%A9%FE%FF%00%EC%BD%B6%CD%5D%E2%29%BE%2F%CDG%3C%A9o%1FJ%E2%FD%F2%ABm%96%BB%C4S%FC_%9A%8Ay%89%23%E9%3C_%F3%25w%DB%1Dw%88%A7%F8%9F4%FC%7F%F0%DB%FC%23%8B%F7%CA%AD%B6%1A%EF%11O%F1%3Ei%F8%F3%FC%23%8B%F7%CB%23mv%BB%C4%C1%F1%3EkY%EA-g%E9%3C_%BE%7F%D1%94v%B1Z%FF%00%83%07%BF%F3QOQ%96%93%F4%A6%28%FDr%CC%3BS%AD%7F%C1%83%DF%F9%ADg%AA%7F%0D%27%E9%9C1%FA%E5%98v%9BV%FF%00%85%0F%BF%F3QOU%94s%F4%DE%1F%DF%2C%E1%B4z%B7%FC%28%7D%FF%00%9A%D7%FA%BC%C4%22%B7%D3%D4%89%FF%004%A5%19W1K%5D%BC%DE%08%86%EE%CD%2C%BB%8D%D7u%FA%2B%A3%D3%B9%9E%BC%CB%8B%D4%F8%15%E3j%22%7D%D2u%D3s%04%04%14X%88%1Eg%DB%AE%20%F2%E3%0D%0F%7BMO%10%B3yR%5D%23%97%BC%3F%A5%7B%0E%83%8BX7%F7%9F%FE%21%BF%BBW%B2%2C1%AAq%BAk%9BQ%A7c%A8v%ED%8Cy%3E%F9%0A%97%ACe%ED%E3%CDa%B5%5D%9B%17%DA%8D%13K%88%D0%E8%ED-%1D5C%8C%87%A6%EAYc%0E0%8F%95w%0D%3Amu%E71p%2F%F92G%CC%A6%84w%20f%17%C3r%A4%B5%82%0D%2B%D3%D4%1B4nV3%DD%28%0Fu%ED%29%B9X%7DNTc%FE%08%F6a%DA%E5Dx%86%0D%87b%606%B9%C8%3A%0B%F1%21%19%A1%22x%EE%F4%A3%15%8E%1CN%1C%B6%C7%29%B0%CA__%9A%292%E5%15%054%C0ep%04v%C6%CD%A8%B4b7%CC%5E%D17%9E%E5Nq%CEkL%B1ZNI%F0%E3%5BK%C5%02%AB%18%A8%92%27b%01%DDF%26%2F%A8%95%B1%8F%1B%BD%2B%95%FC%18%E6%95%D4%BA%9CJM%3D%D1FK%3A%95%F0%CA%CA%B5%AA%B3Y%99w%CD%9C%E4%9C8%F0%D8jf%82%3A%89g%12%22%29F%F6f%B8%85%84D%B872%A5iy%EE%A1%CD%C9%EA%CDq%CE%A2%1C%AF%3A%60%C3C%89TS%C7%F7bLq%B6%BC%C1%23%090%FA%AE%D3%D4%A0%B4%3D%3FN%E4z%B8ki%F7i%19Ah%D3%AD%1E%3C%C2%FDUkJh%B5%A6%1D%B3.l%D6%86L%3A%23%9E3%29%AA%22%19%0AG%22%13%8C%88nm%07%9B%85%DD%2A%CDx%F1%15%F2%F1%3C%DE%BD%C9%AF%2Ab%93%E2%25%C7%EA%60%DD%C8q%EB%AD%86A%AE%9AkiZ%B9%B9%29%11%2F%A0%60%C9%5C%94%8B%B1%B2%AF%3E%16%A3S%E5x%ACkmm%15%B7%89f%17ZvL%C6%D0%5B%26-%F9%97%D5%1B%28u3%3Ab%F6%88%8F-%B4%B8ET1%B4%B2%C3%20F%5C%C6%40%EC%DD%9E%8F%B4%B7%C9%86%F1%E6a%CC%A7%3B%0E%5C%9D%95%B4mdO%AB%2AV%8F%29%EF%11%13%B7%D9%0FC7%17~fe%1E%A6%F3%A8V%CB1%11%BB%3A%B6M%C1%24%A6%88%8E%5E%076%8E%E1%E0%B3k%A6%BD%BC%A5%EAzg%16pWs%F2%F0%DD_%99%5C%D7%D5%3E%12%B5%D4rD%04%14Z%EF%F32%F2%86%D7n%FA%FE%B7%5E%B84%F4~%8F%1A%F7%5D%1FQ%C4%89W%BF%BBu%B0o%F9%89%3A%FE%85.%9F%B9%0A%A9%D7%23%FE%16%FF%00%94%95As%05%DFO%AB%BB%BA%FAUM%DA%F8%5B%E2W8%D3%16%C7XI%0E%B3%950%99%EBr%7DM50o%26%92%A4%AC%06%21%1B%AD%9A%12~Qp%EED%97%07%95%97%D3%E6w%FF%00%7F-%FE%1FN~%A1%2A%1C%BD%85QM%A6%F4j%29%DAFg%D4Y%C69%08%BF%22-%14%3C%7Bz%B9o%91%B6%26%BBo%3A%FD%3A%93%C1%FA1i%E7%DE%16%BF%F5%5Bt%E8%DCJ%D7%13%C3%95%8A%B9%3EgN%A5%3C%AF%05%5B%27%85%ACi%DEU%D9%A5v%27%13N%CF%1D%3C%05%AD%92Is%91%FA%20%3D%EFo%05B%F94%83%3FR%AE%1F%0E%F5%96%B0%21%C3%A8%A2%A4%02y%1A%26.%5B%B6%97%11%11%13%BE%9D%1D%D2%AB%2F%3F%9B7%AD%92o%F7r%EC7%26O%8C%E2%95%B3bZ%D3%EEL%04%E3%87%85%E5m%A3k%96%BC%9B%04_%5E%9B%96%BA%F3%E5%DC%9E%A1%5E%26%1A%D7%0F%99%94O%3B%E5%81%C2%EBw%00Nq%9Cc%28%5D%DD%B3%11%10%DA%FE%17%11U%F2%C3%BD%D1%F9%BF%88%A6%EC%FBr%9E%CF%AA%F1%1B%25%7D%22%A5w%E3%29%3F%28%85%B9%F7c%D3%D5w2%8E%98v%D3%9D%D6%E9%C7%99%A4y%97~%86%8D%A2%80a%8D%DD%98%23h%E3%27%E5%3BZ6%B3%96%BC%EA%DE%A7O%0D9%7B%AF%DF%3Fw%9B%B3%16%13SIU%28U3%DEFf%D2%B8%E82%DC_x%3E%7F%E1qs%D2%7B%BC%BE%A3%D39Xy%18%221%FCDxmr%B6D%A9%C4%A3%29%40%86%28%84%ADc6w%BC%BAXY%BF%BAb%E3M%D5%FA%8F%5D%C5%C2%BCc%98%DC%B4%98%9E%1B-%24%E7O3i%24O%A3%E9%CC%FDD%3D%8E%DCT9%B1N9%D3%A5%C7%E5S%95%87%D5%A7%D9%E8%1C%2F%2FR%8D%00A%BA%06%03%85%AFm%05%EEr%1E.E%DF%3Fj%EC%D7%0D%7D7%CC3%F33O%26m%B9%F1.%1DA%A4%15q%EF4q%86%A0%18%DF%9D%AD%8EN%25%E8%F2W%12%9A%8C%BA%FE_D%E4Zrq%27_5%FF%00%D3%BBfA%03%C3%E7%D5%9C%85%E07k%5BR~O%07e%DC%E4v%CE9%7C%E3%837%AF%26%BE~%5CB%27%E0%CB%C8%CDfo%A7%D1%E6%D1%DB%BD%BA~K%CA%7B%B6j%AA%91%FF%00%E9%A6%B1FM%F7m%D6%5EW%F6%5D%BE%17O%8F%F3%CB%C5%F5~%A99%26q%D3%D9%3B%5D%BD%7C%3C%ECx%F3%2B%D1%91%01%05%16%BE%D0%3C%D1%B7%5C9%E2%C6%1An%F6%A6%9A2g%F2%A3%BA7%F7D%7F5%ECz%15%E2%F8%BB~%DF%EE%86%EDn%C7%F1%16%A7%C7%29%D8%9FF%A8%19%60%D7%CA%21%B9%BD%E1%16Ru%AA%CD%F0%CC%C7%C35u%9Ckd%B4G6%21%5Dv%A5U%04%EF%1C%26%C2%D1CPc%AB%CDw%A5%CA%EC%B8%97%9F%C1%D4o%15%8CQ%F7%FF%00D%B0%D7l%C7%1C%0C%3B%2C%CB%5B%20%91%84%15%12%B9%00is%DCQ%8F%27_Io%CD%C5%DF%C9%F4%E3%EC%DB%7Bs%ED%A3g%D6%C6f%89%E1%03%8A%9E%9CJ%C6%3Bo%29%0A%DDd-%3B%9E%E4%5B%FF%00U%DE%1F%0F%D0%AC%C4%FC%ADb%AF%87b%C6r%956c%A4%A0%AA9%0A7%10%8EK%E3ar%20%90D%8A%3F%25%F5%16%E3%D1%C5q%EB%9Ax%D6%9A%A1%8B%CD%25%C5%F6%8B%83%C7E%8BTC%130%C4%FB%A3%8C%07%98%18%A3%17%B7%F5%5C%BA%1C%7BM%AB%DD.%BF%16%FD%F0%CD%B3%DC%9E%F8%B5c%C6w%0D%3C%23uA%8F%07%EC%8CK%C2w%FE%04%95~M%D2r9%1E%95t%F4%D5%258C%18%C5%18%B0%04b%20%02-%C9%11%1E%0C%2C%B9%97%9D%BC%FC%DF%BE%DB%7D%28%C3%1BF%2C%EE%EC%CC%CE%FD%D3%B3qt%25%06%CF%1B%3F%FA%D6X%A6%09%B7%27%18%EE%C9%9C%2Fb%0B%B5%EB%E0%ED%A9-o%5D%BA%BD%3B%A9%CF%1A%93M%7B%A6tt%81%04A%0Cl%C2%11%80%80%0Bt%08%B7%06J%C6%9C%CC%99-k%CD%A7%E5%9Dm%0D%3D%EC%88%ED%17%04%2A%CC%3C%C60y%26%88%82H%98GS%BB%5B%5D%87%D9%22U%F9%18%BB%E1%D8%E8%BC%DF%C3r%7B%A6%7C%3E%EC%93%85%3D%26%1BO%09%B3%89%D9%7C%82%5C%ECg%CAq%7F5%DAz%96%F8%29%D9M%20%EA%BC%9F%C4r%AD%92%11%BC%D3%90%A5%C4%B1-%EB%98%C3N%D0%C6.l%C2R%13%DCZ%8B7GG%17U%2F%C7%9C%97%DB%A7%D3%FA%D7%E18%D3H%8D%CAm%87%E1q%D3%D3%05%28%B9%18%00n%F52%B8%DD%BB%5D%5D%AE8%8A%E9%C2%CB%9E%F92%FA%BF%3E%E8%B6%19%B3%1A%18%26y%09%E4%9D%98%B5%8E9%1F%92%1E%96%9D%DF%B4%AAS%87%11%7D%BA%B9%BE%A0%E4e%C5%E9%7B%26%EE%3A%B6%9D%0A%EC%D6%25%C5%89%D7%96%9C%F2%C5%13%CA3%EE%40d%17%D5%9CF%D6%D7%AD%D9%B8%3A%82x%D5%DE%F4%B3%1C%EC%B1%1D%BD%D2%DD%B3%2B%0A%A2%02%02%02%0A%2C%7B%CF%FD%19r%CD%B8%E5%B7%AA%C3%86%AE6%D6J%03%23-9%DE%9ENI~V%C6%5Ea%25%D9%E8%BC%9FO7l%FBJ%3B%C3%CEt%F5%07%11%8C%91%BB%81%C6B%60c%DD%09%89%5C%C4%2B%D7d%8A%E4%8E%C9k%0E%9F%8E%ED%A6%AA%B3%0F%2A6%80a%96P%DD%D4T%8C%9A%B1%073%EE%C2%DEM%DEw%E7%5C%1C%7D%1A%29%9B%7B%F1%F0%96%25%A1%C3%F3%DB%C3%82%CD%83n.i%8C%8B%E9%1B%DD-%B8%84%BE%EE%DF%27%C2R%E4%E1o%93%EB%7D%93R%A8%8B%29%E7%F3F%D6%EB%E1%D2rV%D5%A7%C2%E9%5E%90%E1j%98%C5%C9%E9%DD%E4%DD%BCn%5C%ABK%92%FA%8D%DC%7D%A5%C7%E4%F0c-%FB%98%9E%3Ft%A1%B8%AE%29-eL%B5S%BD%D2%CENf%ED%CC%DDB%3EK%0D%AD%EC%A9%3B%3D%3A%F6%AF%F1%E9%D9%0E%F3%B1%28%E3%FA%A8%88%19%98%DE%A2V%95%FA%5C%99%87Ou%C5ryS%F9%9C%DE%7D%A6m%A7KeUF%2B%A5%C8%C8%82%9A%26%D8%98%11%9D%8B%13%3A%92%14%D1fX%F9%D8%8C%C7%DED%F6c%7B%F0%21%E4%D1%19%DA%AC%B1%E5%8D%0B%3EY%F0%AA%02%02%02%02%02%0C3B%12%09Fl%C4%06.%26.%DA%89%09pqu%98%9DN%E0yKh%99%20%F0z%C2%01b%2AI%9C%8A%96W%EA%E9%84%BC%A1%FE%5BG%5E%D3%A6s%23%3E-O%BC%23%98%F2%88%0A%BD%3EcI%E8%B9%946MU%EC%ABYf%AC%8C%AB%DD6%B7%2F%A6%18H%C8%40%05%CC%CC%98D%05%AE%22%22%E6%11%15W7%B2%D7%B4%3D%3D%B3%9C%AAx%5E%1E1J%FA%CD%29o%A6f~H%19%08%8D%83%D8%C2%23%EB%D5p%F3d%EE%97%13%95%97%BAS%15%04%20%85VA%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%079%DB%1E%5B%92%BF%0B%BA%01%BEZI7%EC%0C%DA%91%05%A4%24%23%DB%A1%5D%EC%AE%97J%CF%E8%E6%ED%FB%B10%F3%13%2Fc3%11%3B%86%D5%5E%CA%1B%2CU%7B%2A%D6X%AB%23%2A%F7Y%AA%7B%B2%AC%BB%25n%29%14%8C%CF%B9%A36%9ES%E8b%1E%E4%7D%22%2B%7DBK%97%CC%CB%A8%D2%3EV%5DF%9E%9A%D1q%DC%89%F3%2A%A7%B32%AA%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0A%2C%7B%08%26%3B%B2%5C%22%BAW%98%A2%28%24%27%D4%CA%9C%F7lE%E18%F1%1D%7DJ%FE%1E%A5%97%1Cj%27%FF%00%2C%B5%7Fa8%3F%87W%FB%E1%FE%0AY%EA%B9%FF%00%86%D1e~%C2%B0%8F%0E%AF%F7%C3%FC%16%B3%D4%F36%8C%92%BE-%88%60%E2L%EE%F5F%CD%DE%94%EC%C2%FF%00%A4Y%D4v%EA%19-%EE%DAy%12%9Da8-5%14M%05%2CA%0Cc%CC%20%DC%EF%D6O%CEO%DA%EA%AD%AD6%F7El%93-%92%D1%A8%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%B0%28%9E%01%3C%9A%13%C8%2C%EE%01cF%D5Y%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%1F%FF%D9",
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: true,
    formatting: { startDateHumanizeCutoff: 100 },
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "solano-cpc": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
      display: true,
    },
    goalsTasks: { display: false },
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: true,
    whatIsRiskLevelCalled: "Office",
    supportsAssessment: true,
    showTasksInClientTable: false,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: true,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Solano CPC Case Management",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Compliance",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: true,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: true,
    supportsCalendar: true,
    supportsClasses: true,
    broadcastMessagingBuckets: [
      "all",
      "caseload",
      "risk_level",
      "activity",
      "risk_level_by_sex",
    ],
    supportsChat: true,
    supportsNotes: false,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: false,
    workflow: { display: true },
    supprtsChatLogDownload: false,
    logoDataURI:
      "data:image/jpeg,%FF%D8%FF%E0%00%10JFIF%00%01%01%00%00%01%00%01%00%00%FF%DB%00%84%00%08%06%06%0D%0D%0D%10%0D%0D%10%0F%0D%0E%0D%0F%0E%0F%0D%0D%0E%0D%0F%0E%0D%10%0E%11%10%13%12%1D%0F%10%11%15%18.%1B%15%16%20%17%10%10%1C%2B%1D%20%24%25%28%28%28%15%1B-1%2C%260%22%27%28%26%01%09%09%09%0D%0C%0D%19%0E%0E%18%26%1F%1D%1F%26%26%27%26%26%26%27%27%26%26%26%26%26%27%26%26%27%26%27%26%26%26%26%26%26%26%27%26%26%27%27%26%26%26%26%27%27%26%26%26%26%27%26%26%26%26%26%26%26%26%FF%C0%00%11%08%00z%00%D4%03%01%11%00%02%11%01%03%11%01%FF%C4%00%1C%00%01%00%01%05%01%01%00%00%00%00%00%00%00%00%00%00%00%06%01%02%03%05%07%08%04%FF%C4%00A%10%00%01%03%02%03%03%05%0C%09%04%03%01%00%00%00%00%02%00%01%03%04%12%05%06%11%07%13%21%221AQa2BRSbqr%81%82%A2%A3%D1%14%15%173C%91%92%93%A1T%B1%D2%D35%C2%F1%23%FF%C4%00%1B%01%01%00%02%03%01%01%00%00%00%00%00%00%00%00%00%00%00%03%04%01%02%05%06%07%FF%C4%003%11%01%00%02%02%01%03%03%02%05%02%04%07%00%00%00%00%00%01%02%03%11%04%05%12%21%131A%06Q%14%22BRa%15%F0%162%A1%F1%23Sq%81%91%C1%E1%FF%DA%00%0C%03%01%00%02%11%03%11%00%3F%00%EF%E8%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%28%B1%132J%07%8Fmk%08%A1%90%A1%29Ny%05%F41%A6%0D%E3%09x%24W0%EB%EBW%B1p2%E4%8D%C4%11%0DW%DB%C6%11%E2%EB%3Ff%2F%F6%29%3F%A6gI%14%DA%BFn%D8O%8B%AC%FD%98%BF%D8%B1%FD73x%C12%BE%0D%B8a%04%EC%C45%40%CF%DF%14%22%EC%DF%A4%DD%D4s%C1%BC3%3Ci%94%EF%08%C6%A9%ABai%E9e%19%A3~b%07%E6~%A2nv~%C7U%AFI%AF%BA%2C%94%9A%7B%B6kF%82%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0Es%B6%3C%C7%25%0E%17l%04%E1-%5C%9B%861%7D%08B%D2%22%21%ED%B4m%F6%97G%A6a%8C%B9%3C%FC%12%F3%23%2F_%DB%5Cq%E1%25as%28m6X%AB%2B%3A%82%D6%B2%CDt%BD%95y%FC%D0%B1%1A%84%EFey%86J%2CN%28%D9%DFsXM%04%A1%AF%25%C8%BB%92%F4%98%AD%F5%11.W%2B%0C%7B%A2%E5a%8BWoN2%E4%B8%E2%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0A%21%0C3%CC%11%89Hn%C2%00%CEFN%FA%08%8Bqrt%A5f%F3%A8%26%5ER%DA%16w%93%18%ACr%17%21%A4%85%DCib~%AE%99%88%7C%22%FE%1BF%5E%CF%A6p%BF%0F_%3E%F2%D2%25%12ez%DB%A4%ED%3DW2%82%F13%29%EA%C8%CA%0C%BB%88Y%AF%96Ae%5Eg%C2%C5%2B%A6xe%20%210w%13%12b%12%17%D0%84%87%98%84%95%3C%9B%AA%C6%B7%0FL%EC%DF8%7DkF%CF%26%8DSOhT7%85%D5%2F%B5k%FA%C4%97%1B.%3E%C7%17%95%C7%F4%EC%9B%2A%F1%3BUQn%C6%A4C%CA%AB%0C%8B%26%C5%83%C0%B2j%0D%166x4C%C1%A2%1A4M%9E%04%04%14%D1%3D%CF%22%1A%95%C8%08%08%28%B1%F09%5E%DCs%23%D2%E1%C3I%1B%E9%25y%90%16%8F%C5%A0%8E%D2%2F%CE%E8%C7%CCD%BA%FD%17%8D%EA%E5%DC%FC%23%BC%BC%E5%0CDd%20%0C%E4dL%22%22%DA%91%11rXEz%FC%96%8AS%B9%88t%ACocU%D4t%0FX%F2%C71%C6%1B%CA%8Aq%12%D4%03%A6%D3%EF%F4%E3%AF2%E1%D3%ACV%F7%ED%94%F0%F8%F2%A6%CB%2BqZV%AB%82Zx%E3%220a%90%A4%BFQ%E4%BFr.%B5%E5u%18%C7m%24%EEh%B3.V%AA%C2%AA%3E%8FT%C3%A9%0D%F1%C8%0F%ACr%07%84.%A4%C3%CA%8C%D0%B3%8A%E96O%D9uV%2BLUM%20%D3%C6%EE%E3%0D%E0%E6%F2%B8%F3%97%0Ea%BB%93%AF%9DQ%E4%F2%E2%97%D47%B6%7D%22%98%9E%1B-%25D%94%B3%8D%92%C2V%1Bw%BE%90%F9%25%CE%B6%F5%22%F5%DA%F7%1E%DD%CD%A6T%CD%15%18UC%D4%40%C2n%60%F1%9Cr%5Da%0Fm%BDN%2A%AEjE%E1%26~%3F%AD%E18%FBp%C4%3F%A7%A6%F8%BF%E4%A9N%28%84q%D1%E3%5E%EB%9Bm%F5%FF%00%D3%D3%7C_%9A%8AcIc%A2%D3%F7%2Fm%B6W%FF%00OM%F1~j%29%BE%92%C7%40%A4%FE%A9U%B6%D5%5E%FF%00%81M%F1~j9%CC%9A%3E%9C%C3%3F%AAW6%DA%2B%BCE7%C5%F9%A8%A7%3AX%FAc%0C%FE%A9%FE%FF%00%EC%BD%B6%CD%5D%E2%29%BE%2F%CDG%3C%A9o%1FJ%E2%FD%F2%ABm%96%BB%C4S%FC_%9A%8Ay%89%23%E9%3C_%F3%25w%DB%1Dw%88%A7%F8%9F4%FC%7F%F0%DB%FC%23%8B%F7%CA%AD%B6%1A%EF%11O%F1%3Ei%F8%F3%FC%23%8B%F7%CB%23mv%BB%C4%C1%F1%3EkY%EA-g%E9%3C_%BE%7F%D1%94v%B1Z%FF%00%83%07%BF%F3QOQ%96%93%F4%A6%28%FDr%CC%3BS%AD%7F%C1%83%DF%F9%ADg%AA%7F%0D%27%E9%9C1%FA%E5%98v%9BV%FF%00%85%0F%BF%F3QOU%94s%F4%DE%1F%DF%2C%E1%B4z%B7%FC%28%7D%FF%00%9A%D7%FA%BC%C4%22%B7%D3%D4%89%FF%004%A5%19W1K%5D%BC%DE%08%86%EE%CD%2C%BB%8D%D7u%FA%2B%A3%D3%B9%9E%BC%CB%8B%D4%F8%15%E3j%22%7D%D2u%D3s%04%04%14X%88%1Eg%DB%AE%20%F2%E3%0D%0F%7BMO%10%B3yR%5D%23%97%BC%3F%A5%7B%0E%83%8BX7%F7%9F%FE%21%BF%BBW%B2%2C1%AAq%BAk%9BQ%A7c%A8v%ED%8Cy%3E%F9%0A%97%ACe%ED%E3%CDa%B5%5D%9B%17%DA%8D%13K%88%D0%E8%ED-%1D5C%8C%87%A6%EAYc%0E0%8F%95w%0D%3Amu%E71p%2F%F92G%CC%A6%84w%20f%17%C3r%A4%B5%82%0D%2B%D3%D4%1B4nV3%DD%28%0Fu%ED%29%B9X%7DNTc%FE%08%F6a%DA%E5Dx%86%0D%87b%606%B9%C8%3A%0B%F1%21%19%A1%22x%EE%F4%A3%15%8E%1CN%1C%B6%C7%29%B0%CA__%9A%292%E5%15%054%C0ep%04v%C6%CD%A8%B4b7%CC%5E%D17%9E%E5Nq%CEkL%B1ZNI%F0%E3%5BK%C5%02%AB%18%A8%92%27b%01%DDF%26%2F%A8%95%B1%8F%1B%BD%2B%95%FC%18%E6%95%D4%BA%9CJM%3D%D1FK%3A%95%F0%CA%CA%B5%AA%B3Y%99w%CD%9C%E4%9C8%F0%D8jf%82%3A%89g%12%22%29F%F6f%B8%85%84D%B872%A5iy%EE%A1%CD%C9%EA%CDq%CE%A2%1C%AF%3A%60%C3C%89TS%C7%F7bLq%B6%BC%C1%23%090%FA%AE%D3%D4%A0%B4%3D%3FN%E4z%B8ki%F7i%19Ah%D3%AD%1E%3C%C2%FDUkJh%B5%A6%1D%B3.l%D6%86L%3A%23%9E3%29%AA%22%19%0AG%22%13%8C%88nm%07%9B%85%DD%2A%CDx%F1%15%F2%F1%3C%DE%BD%C9%AF%2Ab%93%E2%25%C7%EA%60%DD%C8q%EB%AD%86A%AE%9AkiZ%B9%B9%29%11%2F%A0%60%C9%5C%94%8B%B1%B2%AF%3E%16%A3S%E5x%ACkmm%15%B7%89f%17ZvL%C6%D0%5B%26-%F9%97%D5%1B%28u3%3Ab%F6%88%8F-%B4%B8ET1%B4%B2%C3%20F%5C%C6%40%EC%DD%9E%8F%B4%B7%C9%86%F1%E6a%CC%A7%3B%0E%5C%9D%95%B4mdO%AB%2AV%8F%29%EF%11%13%B7%D9%0FC7%17~fe%1E%A6%F3%A8V%CB1%11%BB%3A%B6M%C1%24%A6%88%8E%5E%076%8E%E1%E0%B3k%A6%BD%BC%A5%EAzg%16pWs%F2%F0%DD_%99%5C%D7%D5%3E%12%B5%D4rD%04%14Z%EF%F32%F2%86%D7n%FA%FE%B7%5E%B84%F4~%8F%1A%F7%5D%1FQ%C4%89W%BF%BBu%B0o%F9%89%3A%FE%85.%9F%B9%0A%A9%D7%23%FE%16%FF%00%94%95As%05%DFO%AB%BB%BA%FAUM%DA%F8%5B%E2W8%D3%16%C7XI%0E%B3%950%99%EBr%7DM50o%26%92%A4%AC%06%21%1B%AD%9A%12~Qp%EED%97%07%95%97%D3%E6w%FF%00%7F-%FE%1FN~%A1%2A%1C%BD%85QM%A6%F4j%29%DAFg%D4Y%C69%08%BF%22-%14%3C%7Bz%B9o%91%B6%26%BBo%3A%FD%3A%93%C1%FA1i%E7%DE%16%BF%F5%5Bt%E8%DCJ%D7%13%C3%95%8A%B9%3EgN%A5%3C%AF%05%5B%27%85%ACi%DEU%D9%A5v%27%13N%CF%1D%3C%05%AD%92Is%91%FA%20%3D%EFo%05B%F94%83%3FR%AE%1F%0E%F5%96%B0%21%C3%A8%A2%A4%02y%1A%26.%5B%B6%97%11%11%13%BE%9D%1D%D2%AB%2F%3F%9B7%AD%92o%F7r%EC7%26O%8C%E2%95%B3bZ%D3%EEL%04%E3%87%85%E5m%A3k%96%BC%9B%04_%5E%9B%96%BA%F3%E5%DC%9E%A1%5E%26%1A%D7%0F%99%94O%3B%E5%81%C2%EBw%00Nq%9Cc%28%5D%DD%B3%11%10%DA%FE%17%11U%F2%C3%BD%D1%F9%BF%88%A6%EC%FBr%9E%CF%AA%F1%1B%25%7D%22%A5w%E3%29%3F%28%85%B9%F7c%D3%D5w2%8E%98v%D3%9D%D6%E9%C7%99%A4y%97~%86%8D%A2%80a%8D%DD%98%23h%E3%27%E5%3BZ6%B3%96%BC%EA%DE%A7O%0D9%7B%AF%DF%3Fw%9B%B3%16%13SIU%28U3%DEFf%D2%B8%E82%DC_x%3E%7F%E1qs%D2%7B%BC%BE%A3%D39Xy%18%221%FCDxmr%B6D%A9%C4%A3%29%40%86%28%84%ADc6w%BC%BAXY%BF%BAb%E3M%D5%FA%8F%5D%C5%C2%BCc%98%DC%B4%98%9E%1B-%24%E7O3i%24O%A3%E9%CC%FDD%3D%8E%DCT9%B1N9%D3%A5%C7%E5S%95%87%D5%A7%D9%E8%1C%2F%2FR%8D%00A%BA%06%03%85%AFm%05%EEr%1E.E%DF%3Fj%EC%D7%0D%7D7%CC3%F33O%26m%B9%F1.%1DA%A4%15q%EF4q%86%A0%18%DF%9D%AD%8EN%25%E8%F2W%12%9A%8C%BA%FE_D%E4Zrq%27_5%FF%00%D3%BBfA%03%C3%E7%D5%9C%85%E07k%5BR~O%07e%DC%E4v%CE9%7C%E3%837%AF%26%BE~%5CB%27%E0%CB%C8%CDfo%A7%D1%E6%D1%DB%BD%BA~K%CA%7B%B6j%AA%91%FF%00%E9%A6%B1FM%F7m%D6%5EW%F6%5D%BE%17O%8F%F3%CB%C5%F5~%A99%26q%D3%D9%3B%5D%BD%7C%3C%ECx%F3%2B%D1%91%01%05%16%BE%D0%3C%D1%B7%5C9%E2%C6%1An%F6%A6%9A2g%F2%A3%BA7%F7D%7F5%ECz%15%E2%F8%BB~%DF%EE%86%EDn%C7%F1%16%A7%C7%29%D8%9FF%A8%19%60%D7%CA%21%B9%BD%E1%16Ru%AA%CD%F0%CC%C7%C35u%9Ckd%B4G6%21%5Dv%A5U%04%EF%1C%26%C2%D1CPc%AB%CDw%A5%CA%EC%B8%97%9F%C1%D4o%15%8CQ%F7%FF%00D%B0%D7l%C7%1C%0C%3B%2C%CB%5B%20%91%84%15%12%B9%00is%DCQ%8F%27_Io%CD%C5%DF%C9%F4%E3%EC%DB%7Bs%ED%A3g%D6%C6f%89%E1%03%8A%9E%9CJ%C6%3Bo%29%0A%DDd-%3B%9E%E4%5B%FF%00U%DE%1F%0F%D0%AC%C4%FC%ADb%AF%87b%C6r%956c%A4%A0%AA9%0A7%10%8EK%E3ar%20%90D%8A%3F%25%F5%16%E3%D1%C5q%EB%9Ax%D6%9A%A1%8B%CD%25%C5%F6%8B%83%C7E%8BTC%130%C4%FB%A3%8C%07%98%18%A3%17%B7%F5%5C%BA%1C%7BM%AB%DD.%BF%16%FD%F0%CD%B3%DC%9E%F8%B5c%C6w%0D%3C%23uA%8F%07%EC%8CK%C2w%FE%04%95~M%D2r9%1E%95t%F4%D5%258C%18%C5%18%B0%04b%20%02-%C9%11%1E%0C%2C%B9%97%9D%BC%FC%DF%BE%DB%7D%28%C3%1BF%2C%EE%EC%CC%CE%FD%D3%B3qt%25%06%CF%1B%3F%FA%D6X%A6%09%B7%27%18%EE%C9%9C%2Fb%0B%B5%EB%E0%ED%A9-o%5D%BA%BD%3B%A9%CF%1A%93M%7B%A6tt%81%04A%0Cl%C2%11%80%80%0Bt%08%B7%06J%C6%9C%CC%99-k%CD%A7%E5%9Dm%0D%3D%EC%88%ED%17%04%2A%CC%3C%C60y%26%88%82H%98GS%BB%5B%5D%87%D9%22U%F9%18%BB%E1%D8%E8%BC%DF%C3r%7B%A6%7C%3E%EC%93%85%3D%26%1BO%09%B3%89%D9%7C%82%5C%ECg%CAq%7F5%DAz%96%F8%29%D9M%20%EA%BC%9F%C4r%AD%92%11%BC%D3%90%A5%C4%B1-%EB%98%C3N%D0%C6.l%C2R%13%DCZ%8B7GG%17U%2F%C7%9C%97%DB%A7%D3%FA%D7%E18%D3H%8D%CAm%87%E1q%D3%D3%05%28%B9%18%00n%F52%B8%DD%BB%5D%5D%AE8%8A%E9%C2%CB%9E%F92%FA%BF%3E%E8%B6%19%B3%1A%18%26y%09%E4%9D%98%B5%8E9%1F%92%1E%96%9D%DF%B4%AAS%87%11%7D%BA%B9%BE%A0%E4e%C5%E9%7B%26%EE%3A%B6%9D%0A%EC%D6%25%C5%89%D7%96%9C%F2%C5%13%CA3%EE%40d%17%D5%9CF%D6%D7%AD%D9%B8%3A%82x%D5%DE%F4%B3%1C%EC%B1%1D%BD%D2%DD%B3%2B%0A%A2%02%02%02%0A%2C%7B%CF%FD%19r%CD%B8%E5%B7%AA%C3%86%AE6%D6J%03%23-9%DE%9ENI~V%C6%5Ea%25%D9%E8%BC%9FO7l%FBJ%3B%C3%CEt%F5%07%11%8C%91%BB%81%C6B%60c%DD%09%89%5C%C4%2B%D7d%8A%E4%8E%C9k%0E%9F%8E%ED%A6%AA%B3%0F%2A6%80a%96P%DD%D4T%8C%9A%B1%073%EE%C2%DEM%DEw%E7%5C%1C%7D%1A%29%9B%7B%F1%F0%96%25%A1%C3%F3%DB%C3%82%CD%83n.i%8C%8B%E9%1B%DD-%B8%84%BE%EE%DF%27%C2R%E4%E1o%93%EB%7D%93R%A8%8B%29%E7%F3F%D6%EB%E1%D2rV%D5%A7%C2%E9%5E%90%E1j%98%C5%C9%E9%DD%E4%DD%BCn%5C%ABK%92%FA%8D%DC%7D%A5%C7%E4%F0c-%FB%98%9E%3Ft%A1%B8%AE%29-eL%B5S%BD%D2%CENf%ED%CC%DDB%3EK%0D%AD%EC%A9%3B%3D%3A%F6%AF%F1%E9%D9%0E%F3%B1%28%E3%FA%A8%88%19%98%DE%A2V%95%FA%5C%99%87Ou%C5ryS%F9%9C%DE%7D%A6m%A7KeUF%2B%A5%C8%C8%82%9A%26%D8%98%11%9D%8B%13%3A%92%14%D1fX%F9%D8%8C%C7%DED%F6c%7B%F0%21%E4%D1%19%DA%AC%B1%E5%8D%0B%3EY%F0%AA%02%02%02%02%02%0C3B%12%09Fl%C4%06.%26.%DA%89%09pqu%98%9DN%E0yKh%99%20%F0z%C2%01b%2AI%9C%8A%96W%EA%E9%84%BC%A1%FE%5BG%5E%D3%A6s%23%3E-O%BC%23%98%F2%88%0A%BD%3EcI%E8%B9%946MU%EC%ABYf%AC%8C%AB%DD6%B7%2F%A6%18H%C8%40%05%CC%CC%98D%05%AE%22%22%E6%11%15W7%B2%D7%B4%3D%3D%B3%9C%AAx%5E%1E1J%FA%CD%29o%A6f~H%19%08%8D%83%D8%C2%23%EB%D5p%F3d%EE%97%13%95%97%BAS%15%04%20%85VA%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%079%DB%1E%5B%92%BF%0B%BA%01%BEZI7%EC%0C%DA%91%05%A4%24%23%DB%A1%5D%EC%AE%97J%CF%E8%E6%ED%FB%B10%F3%13%2Fc3%11%3B%86%D5%5E%CA%1B%2CU%7B%2A%D6X%AB%23%2A%F7Y%AA%7B%B2%AC%BB%25n%29%14%8C%CF%B9%A36%9ES%E8b%1E%E4%7D%22%2B%7DBK%97%CC%CB%A8%D2%3EV%5DF%9E%9A%D1q%DC%89%F3%2A%A7%B32%AA%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0A%2C%7B%08%26%3B%B2%5C%22%BAW%98%A2%28%24%27%D4%CA%9C%F7lE%E18%F1%1D%7DJ%FE%1E%A5%97%1Cj%27%FF%00%2C%B5%7Fa8%3F%87W%FB%E1%FE%0AY%EA%B9%FF%00%86%D1e~%C2%B0%8F%0E%AF%F7%C3%FC%16%B3%D4%F36%8C%92%BE-%88%60%E2L%EE%F5F%CD%DE%94%EC%C2%FF%00%A4Y%D4v%EA%19-%EE%DAy%12%9Da8-5%14M%05%2CA%0Cc%CC%20%DC%EF%D6O%CEO%DA%EA%AD%AD6%F7El%93-%92%D1%A8%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%B0%28%9E%01%3C%9A%13%C8%2C%EE%01cF%D5Y%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%1F%FF%D9",
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: true,
    formatting: { startDateHumanizeCutoff: 100 },
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "solano-cpc-training": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
      display: true,
    },
    goalsTasks: { display: false },
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: true,
    whatIsRiskLevelCalled: "Office",
    supportsAssessment: true,
    showTasksInClientTable: false,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: true,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "*TRAINING* Solano CPC Case Management *TRAINING*",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Compliance",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: true,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: {},
    supportsBroadcastMessaging: false,
    broadcastMessagingBuckets: [
      "all",
      "caseload",
      "risk_level",
      "risk_level_by_sex",
    ],
    supportsChat: true,
    supportsNotes: false,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: false,
    workflow: { display: true },
    supprtsChatLogDownload: false,
    logoDataURI:
      "data:image/jpeg,%FF%D8%FF%E0%00%10JFIF%00%01%01%00%00%01%00%01%00%00%FF%DB%00%84%00%08%06%06%0D%0D%0D%10%0D%0D%10%0F%0D%0E%0D%0F%0E%0F%0D%0D%0E%0D%0F%0E%0D%10%0E%11%10%13%12%1D%0F%10%11%15%18.%1B%15%16%20%17%10%10%1C%2B%1D%20%24%25%28%28%28%15%1B-1%2C%260%22%27%28%26%01%09%09%09%0D%0C%0D%19%0E%0E%18%26%1F%1D%1F%26%26%27%26%26%26%27%27%26%26%26%26%26%27%26%26%27%26%27%26%26%26%26%26%26%26%27%26%26%27%27%26%26%26%26%27%27%26%26%26%26%27%26%26%26%26%26%26%26%26%FF%C0%00%11%08%00z%00%D4%03%01%11%00%02%11%01%03%11%01%FF%C4%00%1C%00%01%00%01%05%01%01%00%00%00%00%00%00%00%00%00%00%00%06%01%02%03%05%07%08%04%FF%C4%00A%10%00%01%03%02%03%03%05%0C%09%04%03%01%00%00%00%00%02%00%01%03%04%12%05%06%11%07%13%21%221AQa2BRSbqr%81%82%A2%A3%D1%14%15%173C%91%92%93%A1T%B1%D2%D35%C2%F1%23%FF%C4%00%1B%01%01%00%02%03%01%01%00%00%00%00%00%00%00%00%00%00%00%03%04%01%02%05%06%07%FF%C4%003%11%01%00%02%02%01%03%03%02%05%02%04%07%00%00%00%00%00%01%02%03%11%04%05%12%21%131A%06Q%14%22BRa%15%F0%162%A1%F1%23Sq%81%91%C1%E1%FF%DA%00%0C%03%01%00%02%11%03%11%00%3F%00%EF%E8%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%08%28%B1%132J%07%8Fmk%08%A1%90%A1%29Ny%05%F41%A6%0D%E3%09x%24W0%EB%EBW%B1p2%E4%8D%C4%11%0DW%DB%C6%11%E2%EB%3Ff%2F%F6%29%3F%A6gI%14%DA%BFn%D8O%8B%AC%FD%98%BF%D8%B1%FD73x%C12%BE%0D%B8a%04%EC%C45%40%CF%DF%14%22%EC%DF%A4%DD%D4s%C1%BC3%3Ci%94%EF%08%C6%A9%ABai%E9e%19%A3~b%07%E6~%A2nv~%C7U%AFI%AF%BA%2C%94%9A%7B%B6kF%82%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0Es%B6%3C%C7%25%0E%17l%04%E1-%5C%9B%861%7D%08B%D2%22%21%ED%B4m%F6%97G%A6a%8C%B9%3C%FC%12%F3%23%2F_%DB%5Cq%E1%25as%28m6X%AB%2B%3A%82%D6%B2%CDt%BD%95y%FC%D0%B1%1A%84%EFey%86J%2CN%28%D9%DFsXM%04%A1%AF%25%C8%BB%92%F4%98%AD%F5%11.W%2B%0C%7B%A2%E5a%8BWoN2%E4%B8%E2%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0A%21%0C3%CC%11%89Hn%C2%00%CEFN%FA%08%8Bqrt%A5f%F3%A8%26%5ER%DA%16w%93%18%ACr%17%21%A4%85%DCib~%AE%99%88%7C%22%FE%1BF%5E%CF%A6p%BF%0F_%3E%F2%D2%25%12ez%DB%A4%ED%3DW2%82%F13%29%EA%C8%CA%0C%BB%88Y%AF%96Ae%5Eg%C2%C5%2B%A6xe%20%210w%13%12b%12%17%D0%84%87%98%84%95%3C%9B%AA%C6%B7%0FL%EC%DF8%7DkF%CF%26%8DSOhT7%85%D5%2F%B5k%FA%C4%97%1B.%3E%C7%17%95%C7%F4%EC%9B%2A%F1%3BUQn%C6%A4C%CA%AB%0C%8B%26%C5%83%C0%B2j%0D%166x4C%C1%A2%1A4M%9E%04%04%14%D1%3D%CF%22%1A%95%C8%08%08%28%B1%F09%5E%DCs%23%D2%E1%C3I%1B%E9%25y%90%16%8F%C5%A0%8E%D2%2F%CE%E8%C7%CCD%BA%FD%17%8D%EA%E5%DC%FC%23%BC%BC%E5%0CDd%20%0C%E4dL%22%22%DA%91%11rXEz%FC%96%8AS%B9%88t%ACocU%D4t%0FX%F2%C71%C6%1B%CA%8Aq%12%D4%03%A6%D3%EF%F4%E3%AF2%E1%D3%ACV%F7%ED%94%F0%F8%F2%A6%CB%2BqZV%AB%82Zx%E3%220a%90%A4%BFQ%E4%BFr.%B5%E5u%18%C7m%24%EEh%B3.V%AA%C2%AA%3E%8FT%C3%A9%0D%F1%C8%0F%ACr%07%84.%A4%C3%CA%8C%D0%B3%8A%E96O%D9uV%2BLUM%20%D3%C6%EE%E3%0D%E0%E6%F2%B8%F3%97%0Ea%BB%93%AF%9DQ%E4%F2%E2%97%D47%B6%7D%22%98%9E%1B-%25D%94%B3%8D%92%C2V%1Bw%BE%90%F9%25%CE%B6%F5%22%F5%DA%F7%1E%DD%CD%A6T%CD%15%18UC%D4%40%C2n%60%F1%9Cr%5Da%0Fm%BDN%2A%AEjE%E1%26~%3F%AD%E18%FBp%C4%3F%A7%A6%F8%BF%E4%A9N%28%84q%D1%E3%5E%EB%9Bm%F5%FF%00%D3%D3%7C_%9A%8AcIc%A2%D3%F7%2Fm%B6W%FF%00OM%F1~j%29%BE%92%C7%40%A4%FE%A9U%B6%D5%5E%FF%00%81M%F1~j9%CC%9A%3E%9C%C3%3F%AAW6%DA%2B%BCE7%C5%F9%A8%A7%3AX%FAc%0C%FE%A9%FE%FF%00%EC%BD%B6%CD%5D%E2%29%BE%2F%CDG%3C%A9o%1FJ%E2%FD%F2%ABm%96%BB%C4S%FC_%9A%8Ay%89%23%E9%3C_%F3%25w%DB%1Dw%88%A7%F8%9F4%FC%7F%F0%DB%FC%23%8B%F7%CA%AD%B6%1A%EF%11O%F1%3Ei%F8%F3%FC%23%8B%F7%CB%23mv%BB%C4%C1%F1%3EkY%EA-g%E9%3C_%BE%7F%D1%94v%B1Z%FF%00%83%07%BF%F3QOQ%96%93%F4%A6%28%FDr%CC%3BS%AD%7F%C1%83%DF%F9%ADg%AA%7F%0D%27%E9%9C1%FA%E5%98v%9BV%FF%00%85%0F%BF%F3QOU%94s%F4%DE%1F%DF%2C%E1%B4z%B7%FC%28%7D%FF%00%9A%D7%FA%BC%C4%22%B7%D3%D4%89%FF%004%A5%19W1K%5D%BC%DE%08%86%EE%CD%2C%BB%8D%D7u%FA%2B%A3%D3%B9%9E%BC%CB%8B%D4%F8%15%E3j%22%7D%D2u%D3s%04%04%14X%88%1Eg%DB%AE%20%F2%E3%0D%0F%7BMO%10%B3yR%5D%23%97%BC%3F%A5%7B%0E%83%8BX7%F7%9F%FE%21%BF%BBW%B2%2C1%AAq%BAk%9BQ%A7c%A8v%ED%8Cy%3E%F9%0A%97%ACe%ED%E3%CDa%B5%5D%9B%17%DA%8D%13K%88%D0%E8%ED-%1D5C%8C%87%A6%EAYc%0E0%8F%95w%0D%3Amu%E71p%2F%F92G%CC%A6%84w%20f%17%C3r%A4%B5%82%0D%2B%D3%D4%1B4nV3%DD%28%0Fu%ED%29%B9X%7DNTc%FE%08%F6a%DA%E5Dx%86%0D%87b%606%B9%C8%3A%0B%F1%21%19%A1%22x%EE%F4%A3%15%8E%1CN%1C%B6%C7%29%B0%CA__%9A%292%E5%15%054%C0ep%04v%C6%CD%A8%B4b7%CC%5E%D17%9E%E5Nq%CEkL%B1ZNI%F0%E3%5BK%C5%02%AB%18%A8%92%27b%01%DDF%26%2F%A8%95%B1%8F%1B%BD%2B%95%FC%18%E6%95%D4%BA%9CJM%3D%D1FK%3A%95%F0%CA%CA%B5%AA%B3Y%99w%CD%9C%E4%9C8%F0%D8jf%82%3A%89g%12%22%29F%F6f%B8%85%84D%B872%A5iy%EE%A1%CD%C9%EA%CDq%CE%A2%1C%AF%3A%60%C3C%89TS%C7%F7bLq%B6%BC%C1%23%090%FA%AE%D3%D4%A0%B4%3D%3FN%E4z%B8ki%F7i%19Ah%D3%AD%1E%3C%C2%FDUkJh%B5%A6%1D%B3.l%D6%86L%3A%23%9E3%29%AA%22%19%0AG%22%13%8C%88nm%07%9B%85%DD%2A%CDx%F1%15%F2%F1%3C%DE%BD%C9%AF%2Ab%93%E2%25%C7%EA%60%DD%C8q%EB%AD%86A%AE%9AkiZ%B9%B9%29%11%2F%A0%60%C9%5C%94%8B%B1%B2%AF%3E%16%A3S%E5x%ACkmm%15%B7%89f%17ZvL%C6%D0%5B%26-%F9%97%D5%1B%28u3%3Ab%F6%88%8F-%B4%B8ET1%B4%B2%C3%20F%5C%C6%40%EC%DD%9E%8F%B4%B7%C9%86%F1%E6a%CC%A7%3B%0E%5C%9D%95%B4mdO%AB%2AV%8F%29%EF%11%13%B7%D9%0FC7%17~fe%1E%A6%F3%A8V%CB1%11%BB%3A%B6M%C1%24%A6%88%8E%5E%076%8E%E1%E0%B3k%A6%BD%BC%A5%EAzg%16pWs%F2%F0%DD_%99%5C%D7%D5%3E%12%B5%D4rD%04%14Z%EF%F32%F2%86%D7n%FA%FE%B7%5E%B84%F4~%8F%1A%F7%5D%1FQ%C4%89W%BF%BBu%B0o%F9%89%3A%FE%85.%9F%B9%0A%A9%D7%23%FE%16%FF%00%94%95As%05%DFO%AB%BB%BA%FAUM%DA%F8%5B%E2W8%D3%16%C7XI%0E%B3%950%99%EBr%7DM50o%26%92%A4%AC%06%21%1B%AD%9A%12~Qp%EED%97%07%95%97%D3%E6w%FF%00%7F-%FE%1FN~%A1%2A%1C%BD%85QM%A6%F4j%29%DAFg%D4Y%C69%08%BF%22-%14%3C%7Bz%B9o%91%B6%26%BBo%3A%FD%3A%93%C1%FA1i%E7%DE%16%BF%F5%5Bt%E8%DCJ%D7%13%C3%95%8A%B9%3EgN%A5%3C%AF%05%5B%27%85%ACi%DEU%D9%A5v%27%13N%CF%1D%3C%05%AD%92Is%91%FA%20%3D%EFo%05B%F94%83%3FR%AE%1F%0E%F5%96%B0%21%C3%A8%A2%A4%02y%1A%26.%5B%B6%97%11%11%13%BE%9D%1D%D2%AB%2F%3F%9B7%AD%92o%F7r%EC7%26O%8C%E2%95%B3bZ%D3%EEL%04%E3%87%85%E5m%A3k%96%BC%9B%04_%5E%9B%96%BA%F3%E5%DC%9E%A1%5E%26%1A%D7%0F%99%94O%3B%E5%81%C2%EBw%00Nq%9Cc%28%5D%DD%B3%11%10%DA%FE%17%11U%F2%C3%BD%D1%F9%BF%88%A6%EC%FBr%9E%CF%AA%F1%1B%25%7D%22%A5w%E3%29%3F%28%85%B9%F7c%D3%D5w2%8E%98v%D3%9D%D6%E9%C7%99%A4y%97~%86%8D%A2%80a%8D%DD%98%23h%E3%27%E5%3BZ6%B3%96%BC%EA%DE%A7O%0D9%7B%AF%DF%3Fw%9B%B3%16%13SIU%28U3%DEFf%D2%B8%E82%DC_x%3E%7F%E1qs%D2%7B%BC%BE%A3%D39Xy%18%221%FCDxmr%B6D%A9%C4%A3%29%40%86%28%84%ADc6w%BC%BAXY%BF%BAb%E3M%D5%FA%8F%5D%C5%C2%BCc%98%DC%B4%98%9E%1B-%24%E7O3i%24O%A3%E9%CC%FDD%3D%8E%DCT9%B1N9%D3%A5%C7%E5S%95%87%D5%A7%D9%E8%1C%2F%2FR%8D%00A%BA%06%03%85%AFm%05%EEr%1E.E%DF%3Fj%EC%D7%0D%7D7%CC3%F33O%26m%B9%F1.%1DA%A4%15q%EF4q%86%A0%18%DF%9D%AD%8EN%25%E8%F2W%12%9A%8C%BA%FE_D%E4Zrq%27_5%FF%00%D3%BBfA%03%C3%E7%D5%9C%85%E07k%5BR~O%07e%DC%E4v%CE9%7C%E3%837%AF%26%BE~%5CB%27%E0%CB%C8%CDfo%A7%D1%E6%D1%DB%BD%BA~K%CA%7B%B6j%AA%91%FF%00%E9%A6%B1FM%F7m%D6%5EW%F6%5D%BE%17O%8F%F3%CB%C5%F5~%A99%26q%D3%D9%3B%5D%BD%7C%3C%ECx%F3%2B%D1%91%01%05%16%BE%D0%3C%D1%B7%5C9%E2%C6%1An%F6%A6%9A2g%F2%A3%BA7%F7D%7F5%ECz%15%E2%F8%BB~%DF%EE%86%EDn%C7%F1%16%A7%C7%29%D8%9FF%A8%19%60%D7%CA%21%B9%BD%E1%16Ru%AA%CD%F0%CC%C7%C35u%9Ckd%B4G6%21%5Dv%A5U%04%EF%1C%26%C2%D1CPc%AB%CDw%A5%CA%EC%B8%97%9F%C1%D4o%15%8CQ%F7%FF%00D%B0%D7l%C7%1C%0C%3B%2C%CB%5B%20%91%84%15%12%B9%00is%DCQ%8F%27_Io%CD%C5%DF%C9%F4%E3%EC%DB%7Bs%ED%A3g%D6%C6f%89%E1%03%8A%9E%9CJ%C6%3Bo%29%0A%DDd-%3B%9E%E4%5B%FF%00U%DE%1F%0F%D0%AC%C4%FC%ADb%AF%87b%C6r%956c%A4%A0%AA9%0A7%10%8EK%E3ar%20%90D%8A%3F%25%F5%16%E3%D1%C5q%EB%9Ax%D6%9A%A1%8B%CD%25%C5%F6%8B%83%C7E%8BTC%130%C4%FB%A3%8C%07%98%18%A3%17%B7%F5%5C%BA%1C%7BM%AB%DD.%BF%16%FD%F0%CD%B3%DC%9E%F8%B5c%C6w%0D%3C%23uA%8F%07%EC%8CK%C2w%FE%04%95~M%D2r9%1E%95t%F4%D5%258C%18%C5%18%B0%04b%20%02-%C9%11%1E%0C%2C%B9%97%9D%BC%FC%DF%BE%DB%7D%28%C3%1BF%2C%EE%EC%CC%CE%FD%D3%B3qt%25%06%CF%1B%3F%FA%D6X%A6%09%B7%27%18%EE%C9%9C%2Fb%0B%B5%EB%E0%ED%A9-o%5D%BA%BD%3B%A9%CF%1A%93M%7B%A6tt%81%04A%0Cl%C2%11%80%80%0Bt%08%B7%06J%C6%9C%CC%99-k%CD%A7%E5%9Dm%0D%3D%EC%88%ED%17%04%2A%CC%3C%C60y%26%88%82H%98GS%BB%5B%5D%87%D9%22U%F9%18%BB%E1%D8%E8%BC%DF%C3r%7B%A6%7C%3E%EC%93%85%3D%26%1BO%09%B3%89%D9%7C%82%5C%ECg%CAq%7F5%DAz%96%F8%29%D9M%20%EA%BC%9F%C4r%AD%92%11%BC%D3%90%A5%C4%B1-%EB%98%C3N%D0%C6.l%C2R%13%DCZ%8B7GG%17U%2F%C7%9C%97%DB%A7%D3%FA%D7%E18%D3H%8D%CAm%87%E1q%D3%D3%05%28%B9%18%00n%F52%B8%DD%BB%5D%5D%AE8%8A%E9%C2%CB%9E%F92%FA%BF%3E%E8%B6%19%B3%1A%18%26y%09%E4%9D%98%B5%8E9%1F%92%1E%96%9D%DF%B4%AAS%87%11%7D%BA%B9%BE%A0%E4e%C5%E9%7B%26%EE%3A%B6%9D%0A%EC%D6%25%C5%89%D7%96%9C%F2%C5%13%CA3%EE%40d%17%D5%9CF%D6%D7%AD%D9%B8%3A%82x%D5%DE%F4%B3%1C%EC%B1%1D%BD%D2%DD%B3%2B%0A%A2%02%02%02%0A%2C%7B%CF%FD%19r%CD%B8%E5%B7%AA%C3%86%AE6%D6J%03%23-9%DE%9ENI~V%C6%5Ea%25%D9%E8%BC%9FO7l%FBJ%3B%C3%CEt%F5%07%11%8C%91%BB%81%C6B%60c%DD%09%89%5C%C4%2B%D7d%8A%E4%8E%C9k%0E%9F%8E%ED%A6%AA%B3%0F%2A6%80a%96P%DD%D4T%8C%9A%B1%073%EE%C2%DEM%DEw%E7%5C%1C%7D%1A%29%9B%7B%F1%F0%96%25%A1%C3%F3%DB%C3%82%CD%83n.i%8C%8B%E9%1B%DD-%B8%84%BE%EE%DF%27%C2R%E4%E1o%93%EB%7D%93R%A8%8B%29%E7%F3F%D6%EB%E1%D2rV%D5%A7%C2%E9%5E%90%E1j%98%C5%C9%E9%DD%E4%DD%BCn%5C%ABK%92%FA%8D%DC%7D%A5%C7%E4%F0c-%FB%98%9E%3Ft%A1%B8%AE%29-eL%B5S%BD%D2%CENf%ED%CC%DDB%3EK%0D%AD%EC%A9%3B%3D%3A%F6%AF%F1%E9%D9%0E%F3%B1%28%E3%FA%A8%88%19%98%DE%A2V%95%FA%5C%99%87Ou%C5ryS%F9%9C%DE%7D%A6m%A7KeUF%2B%A5%C8%C8%82%9A%26%D8%98%11%9D%8B%13%3A%92%14%D1fX%F9%D8%8C%C7%DED%F6c%7B%F0%21%E4%D1%19%DA%AC%B1%E5%8D%0B%3EY%F0%AA%02%02%02%02%02%0C3B%12%09Fl%C4%06.%26.%DA%89%09pqu%98%9DN%E0yKh%99%20%F0z%C2%01b%2AI%9C%8A%96W%EA%E9%84%BC%A1%FE%5BG%5E%D3%A6s%23%3E-O%BC%23%98%F2%88%0A%BD%3EcI%E8%B9%946MU%EC%ABYf%AC%8C%AB%DD6%B7%2F%A6%18H%C8%40%05%CC%CC%98D%05%AE%22%22%E6%11%15W7%B2%D7%B4%3D%3D%B3%9C%AAx%5E%1E1J%FA%CD%29o%A6f~H%19%08%8D%83%D8%C2%23%EB%D5p%F3d%EE%97%13%95%97%BAS%15%04%20%85VA%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%01%079%DB%1E%5B%92%BF%0B%BA%01%BEZI7%EC%0C%DA%91%05%A4%24%23%DB%A1%5D%EC%AE%97J%CF%E8%E6%ED%FB%B10%F3%13%2Fc3%11%3B%86%D5%5E%CA%1B%2CU%7B%2A%D6X%AB%23%2A%F7Y%AA%7B%B2%AC%BB%25n%29%14%8C%CF%B9%A36%9ES%E8b%1E%E4%7D%22%2B%7DBK%97%CC%CB%A8%D2%3EV%5DF%9E%9A%D1q%DC%89%F3%2A%A7%B32%AA%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%02%0A%2C%7B%08%26%3B%B2%5C%22%BAW%98%A2%28%24%27%D4%CA%9C%F7lE%E18%F1%1D%7DJ%FE%1E%A5%97%1Cj%27%FF%00%2C%B5%7Fa8%3F%87W%FB%E1%FE%0AY%EA%B9%FF%00%86%D1e~%C2%B0%8F%0E%AF%F7%C3%FC%16%B3%D4%F36%8C%92%BE-%88%60%E2L%EE%F5F%CD%DE%94%EC%C2%FF%00%A4Y%D4v%EA%19-%EE%DAy%12%9Da8-5%14M%05%2CA%0Cc%CC%20%DC%EF%D6O%CEO%DA%EA%AD%AD6%F7El%93-%92%D1%A8%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%80%B0%28%9E%01%3C%9A%13%C8%2C%EE%01cF%D5Y%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%04%1F%FF%D9",
    deactivation: {
      allowDeactivation: false,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: { startDateHumanizeCutoff: 100 },
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  kentucky: {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all fellows in the program or just those in a specific cohort.",
    },
    goalsTasks: {},
    supportsClientProfile: false,
    helpUrl:
      "https://drive.google.com/open?id=1v1F-5nipNYiIv22WV1cVame7X1a4ujhv",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: true,
    whatIsRiskLevelCalled: "Cohort",
    supportsAssessment: false,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: false,
    showSmsStatusInClientTable: true,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Cities United Civic Engagement Fellowship",
    clientDisplayTerm: "Fellow",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Progress",
    whatIsDispositionCalled: "Disposition",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: false,
      access_code: true,
      joined: false,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: true,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: { display: false },
    supportsBroadcastMessaging: true,
    supportsCalendar: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
    supportsChat: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: false,
    workflow: { display: false },
    supprtsChatLogDownload: false,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: true,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: true,
    formatting: {},
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
  "promise-playground": {
    messages: {
      broadcastMessagesHeaderString:
        "Schedule messages to be sent to all client or a specific group.",
    },
    goalsTasks: {},
    supportsClientProfile: false,
    helpUrl: "",
    supportsCarePlanEditing: true,
    supportsProgramCompliance: false,
    whatIsRiskLevelCalled: "Type",
    supportsAssessment: true,
    showTasksInClientTable: true,
    showEventsInClientTable: true,
    showProgramTitleInClientTable: false,
    showRiskLevelInClientTable: true,
    showSmsStatusInClientTable: false,
    showStartDateInClientTable: false,
    showAddressInClientTable: false,
    showHasAppInClientTable: false,
    showDataUpdateNeededInClientTable: false,
    clientListPageName: "Clients",
    clientDisplayTerm: "Client",
    caseManagerDisplayTerm: "Case Manager",
    whatIsComplianceCalled: "Compliance",
    whatIsDispositionCalled: "Outcome",
    clientDetailsColumnsToDisplay: {
      address: false,
      phone: true,
      name: true,
      case_manager: true,
      cases: false,
      language: true,
      access_code: true,
      joined: false,
      supervision_begin_date: false,
      supervision_end_date: false,
      sms_consent: true,
      sms_enabled: true,
      risk_level: true,
      compliance: false,
      currentDevice: false,
    },
    sortClientListByNextEvent: false,
    clientProfileAdditionalRows: {},
    timeline: { display: true },
    supportsBroadcastMessaging: true,
    broadcastMessagingBuckets: ["all", "caseload", "risk_level", "activity"],
    supportsChat: true,
    supportsAddingObligationsToCarePlan: true,
    supportsDateRangesOnObligations: true,
    workflow: { display: true },
    supprtsChatLogDownload: false,
    logoDataURI: null,
    deactivation: {
      allowDeactivation: true,
      populateEndDateOnDeactivation: false,
    },
    showRecurrence: false,
    formatting: {},
    showAnalyticsReportLink: false,
    lastNameFirst: false,
    eventAttendanceTitles: defaultEventAttendanceTitles,
  },
};
let CattFlags: CattFeatureFlagDefs;

export function getFeatureFlags(): FeatureFlagsDefs {
  const projectId = sniffProject();

  // exact match first; substring match second
  const key =
    Object.keys(CLIENT_CONFIGS).find((key) => key === projectId) ||
    Object.keys(CLIENT_CONFIGS).find((key) => projectId.indexOf(key) > -1);

  return key ? CLIENT_CONFIGS[key] : DEFAULT_FLAGS;
}

export function getCattFeatureFlag(key: string): any {
  const flags: CattFeatureFlagDefs = CattFlags as CattFeatureFlagDefs;
  return (flags as any)[key];
}

export function setCattFeatureFlags(newFlags: CattFeatureFlagDefs) {
  return (CattFlags = newFlags);
}
